<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_21683_42856)">
            <path
                d="M11.2507 3.04378C11.6188 3.04378 11.9173 2.74531 11.9173 2.37712C11.9173 2.00893 11.6188 1.71045 11.2507 1.71045C10.8825 1.71045 10.584 2.00893 10.584 2.37712C10.584 2.74531 10.8825 3.04378 11.2507 3.04378Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M13.6335 5.42269C14.0017 5.42269 14.3001 5.12421 14.3001 4.75602C14.3001 4.38783 14.0017 4.08936 13.6335 4.08936C13.2653 4.08936 12.9668 4.38783 12.9668 4.75602C12.9668 5.12421 13.2653 5.42269 13.6335 5.42269Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.5007 8.67269C14.8688 8.67269 15.1673 8.37421 15.1673 8.00602C15.1673 7.63783 14.8688 7.33936 14.5007 7.33936C14.1325 7.33936 13.834 7.63783 13.834 8.00602C13.834 8.37421 14.1325 8.67269 14.5007 8.67269Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M13.6296 11.9227C13.9977 11.9227 14.2962 11.6242 14.2962 11.256C14.2962 10.8878 13.9977 10.5894 13.6296 10.5894C13.2614 10.5894 12.9629 10.8878 12.9629 11.256C12.9629 11.6242 13.2614 11.9227 13.6296 11.9227Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M11.2507 14.3021C11.6188 14.3021 11.9173 14.0036 11.9173 13.6354C11.9173 13.2672 11.6188 12.9688 11.2507 12.9688C10.8825 12.9688 10.584 13.2672 10.584 13.6354C10.584 14.0036 10.8825 14.3021 11.2507 14.3021Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8.00065 15.1668C8.36884 15.1668 8.66732 14.8684 8.66732 14.5002C8.66732 14.132 8.36884 13.8335 8.00065 13.8335C7.63246 13.8335 7.33398 14.132 7.33398 14.5002C7.33398 14.8684 7.63246 15.1668 8.00065 15.1668Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M4.75065 14.3021C5.11884 14.3021 5.41732 14.0036 5.41732 13.6354C5.41732 13.2672 5.11884 12.9688 4.75065 12.9688C4.38246 12.9688 4.08398 13.2672 4.08398 13.6354C4.08398 14.0036 4.38246 14.3021 4.75065 14.3021Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.37174 11.9227C2.73993 11.9227 3.03841 11.6242 3.03841 11.256C3.03841 10.8878 2.73993 10.5894 2.37174 10.5894C2.00355 10.5894 1.70508 10.8878 1.70508 11.256C1.70508 11.6242 2.00355 11.9227 2.37174 11.9227Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M1.50065 8.67269C1.86884 8.67269 2.16732 8.37421 2.16732 8.00602C2.16732 7.63783 1.86884 7.33936 1.50065 7.33936C1.13246 7.33936 0.833984 7.63783 0.833984 8.00602C0.833984 8.37421 1.13246 8.67269 1.50065 8.67269Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M2.37174 5.42269C2.73993 5.42269 3.03841 5.12421 3.03841 4.75602C3.03841 4.38783 2.73993 4.08936 2.37174 4.08936C2.00355 4.08936 1.70508 4.38783 1.70508 4.75602C1.70508 5.12421 2.00355 5.42269 2.37174 5.42269Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M4.75065 3.04378C5.11884 3.04378 5.41732 2.74531 5.41732 2.37712C5.41732 2.00893 5.11884 1.71045 4.75065 1.71045C4.38246 1.71045 4.08398 2.00893 4.08398 2.37712C4.08398 2.74531 4.38246 3.04378 4.75065 3.04378Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M8.00065 2.16683C8.36884 2.16683 8.66732 1.86835 8.66732 1.50016C8.66732 1.13197 8.36884 0.833496 8.00065 0.833496C7.63246 0.833496 7.33398 1.13197 7.33398 1.50016C7.33398 1.86835 7.63246 2.16683 8.00065 2.16683Z"
                stroke="#4A4A4A"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_21683_42856">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
